export function SiteFooter() {
  return (
    <footer className="border-border bg-background border-t py-8">
      <div className="text-muted-foreground mx-auto max-w-7xl px-4 text-center text-sm">
        &copy; {new Date().getFullYear()} Fairmeadow Capital. All rights reserved.
      </div>
    </footer>
  )
}
